import React from "react";
import avatar from "../assets/images/avatar.avif";
import CallToAction from "./CallToAction";
import extraData from "../data/extraData";

function ProfileDetails() {
	return (
		<section className="desktopMaxWidth profileDetailsSection">
			<div className="sectionHeroContainer ">
				<img className="avatar" src={avatar} alt="Profile Avatar" />
				<div>
					<p className="profileName heroText">Irene Nkemazem</p>
					<p className="sectionHeroText">Registered Social Worker</p>
					<p className="sectionHeroText">BA, MA, MSW, RSW (She, her)</p>
				</div>
				<div className="socialIconsContainer">
					<i className="fa-brands fa-twitter"></i>
					<i className="fa-brands fa-facebook"></i>
					<i className="fa-brands fa-linkedin-in"></i>
				</div>
			</div>
			<div className="aboutMeContainer">
				<div className="profileSectionContainers">
					<p className="aboutMeTitle profileSectionTitle tag">About Me</p>
					<p className="profileSectionText">
						I completed a BA degree in English Studies from the University if
						Yaoundé, Cameroon, a Master's degree in Gerontology from the
						University of Regina, and a Master of Social Work (MSW) from the
						University of Botswana and the University of Regina. I am a
						registered Social Worker with the Saskatchewan Association of Social
						Workers and a member of the Canadian Counselling and Psychotherapy
						Association.
					</p>
				</div>
				<div className="experienceContainer profileSectionContainers">
					<p className="experienceTitle profileSectionTitle tag">My Approach</p>
					<p className="profileSectionText">
						As an African/Canadian, my diverse cultural background and extensive
						professional experience in Africa and Canada is the cornerstone of
						my practice. My approach integrates Cognitive Behavioral Therapy
						(CBT) and Acceptance and Commitment Therapy (ACT) collaboratively to
						create unique plans to address problems affecting clients. <br />
						<br />I use CBT and ACT in combination with Solution- Focused Brief
						Therapy, Narrative Therapy, Internal Family System (IFS) therapy for
						couples, Dialectical Behavior Therapy (DBT) and Gottman method
						approaches to help clients heal. I seek to help clients learn tools
						and techniques that they can apply to real life situations and
						problems. <br />
						<br />
						Further, I use a culturally sensitive counseling technique rooted in
						personal experiences and understanding of BIPOC. I have worked
						extensively with Blacks, Indigenous, and Persons of Color (BIPOC) on
						anxiety, PTSD, marital/relationship, parent/teen conflict, life
						transitions, racism, workplace conflict, sexuality, and immigration
						problems.
					</p>
				</div>

				<div className="extraInformationContainer">
					<div className="topExpertiseContainer profileSectionContainers cancellationPolicy">
						<p className="topExpertiseTitle profileSectionTitle tag visionCardTag">
							Top Specialities
						</p>
						<ul className="profileSectionText keyPoints policies">
							{extraData.expertise.map((item, index) => (
								<li key={index}>{item}</li>
							))}
						</ul>
					</div>
					<div className="treatmentApproachesContainer profileSectionContainers cancellationPolicy">
						<p className="treatmentApproachesTitle profileSectionTitle tag visionCardTag">
							Treatment Approaches
						</p>
						<ul className="profileSectionText keyPoints policies">
							{extraData.treatmentApproaches.map((item, index) => (
								<li key={index}>{item}</li>
							))}
						</ul>
					</div>

					<div className="ageGroupsContainer profileSectionContainers cancellationPolicy">
						<p className="ageGroupsTitle profileSectionTitle tag visionCardTag">
							Age Groups
						</p>
						<ul className="profileSectionText keyPoints policies">
							{extraData.ageGroups.map((item, index) => (
								<li key={index}>{item}</li>
							))}
						</ul>
					</div>
					<div className="audienceContainer profileSectionContainers cancellationPolicy">
						<p className="audienceTitle profileSectionTitle tag visionCardTag">
							Audience
						</p>
						<ul className="profileSectionText keyPoints policies">
							{extraData.audience.map((item, index) => (
								<li key={index}>{item}</li>
							))}
						</ul>
					</div>
				</div>
			</div>

			<CallToAction />
		</section>
	);
}

export default ProfileDetails;
